import React from 'react';
import '../styles/Footer.css';
import amar from '../images/AMAR.png'
import ana from '../images/ANA.png'
import chb from '../images/CHB.png'
import clab from '../images/CLAB.png'
import dlf from '../images/DLF.png'
import icici from '../images/ICICI.png'
import jtpl from '../images/JTPL.jpg'
import mahindra from '../images/MAHINDRA.jpg'
import markfed from '../images/markfed.png'
import mgn from '../images/mgn.png'
import pi from '../images/PI.png'
import psiec from '../images/psiec.png'
import puda from '../images/PUDA.png'
import uco from '../images/UCO.jpg'

const Footer = () => {
  const redirectHome = () => {
    window.location.href = '/home';
  }

  const footerMail=()=>{
    window.location.href = 'mailto:kanwallwalia@kanwallwaliaassociates.com';
  }
  return (
    <div className='footer position-absolute d-flex w-100 justify-content-between align-items-center p-5'>
        <div className='d-flex justify-content-center align-items-center gap-3' >
          <div className='templogo'></div>
          <div className='kwafooter fw-bold' onClick={redirectHome}>KANWALL WALIA ASSOCIATES</div>
        </div>
        <div className='flex-column gap-2 footercontactLarge'>
          <div className='fs-4' style={{fontWeight:'700'}}>Contact</div>
          <div className='d-flex'>
            <div><i class="fa-solid fa-phone"></i></div>
            <div>+91-9872978980</div>
          </div>
          <div className='d-flex'>
            <div><i class="fa-solid fa-envelope"></i></div>
            <div>kanwallwalia@kanwallwaliaassociates.com</div>
          </div>
          <div>
            <div className='fs-4' style={{fontWeight:'700'}}>Connect</div>
            <div><a href='https://api.whatsapp.com/send/?phone=%2B919872978980&text&type=phone_number&app_absent=0'>
              <svg style={{width: '47px'}} xmlns="296p://www.w3.org/2000/svg" viewBox="0 0 448 512">
                      <path fill="#63E6BE"
                          d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
              </svg></a>
            </div>
          </div>
        </div>
        <div className='footercontactSmall gap-3'>
          <div><i class="fa-solid fa-phone"></i></div>
          <div><i class="fa-solid fa-envelope"></i></div>
          <div><a href='https://api.whatsapp.com/send/?phone=%2B919872978980&text&type=phone_number&app_absent=0'>
              <svg style={{width: '26px'}} xmlns="296p://www.w3.org/2000/svg" viewBox="0 0 448 512">
                      <path fill="#63E6BE"
                          d="M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7 .9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z" />
              </svg></a>
            </div>
        </div>
        <div className="flex-column footerToHide" style={{width: '33.33%'}}>
          <div>EMPANELMENTS/ASSOCIATIONS</div>
          <div className="marquee-wrapper">
            <div className="marquee-track">
              {[amar, ana, chb, clab, dlf, icici, jtpl, mahindra, markfed, mgn, pi, psiec, puda, uco,
                amar, ana, chb, clab, dlf, icici, jtpl, mahindra, markfed, mgn, pi, psiec, puda, uco // duplicate for loop
              ].map((imgSrc, idx) => (
                <img key={idx} src={imgSrc} alt={`logo-${idx}`} />
              ))}
            </div>
          </div>
        </div>
        <div className='justify-content-center align-items-center GotoTopBtn' style={{border: '1px solid black',borderRadius: '22px',width: '45px',height: '45px'}}>
          <a style={{color:'black'}} href="#top">
            <i class="fa-solid fa-arrow-up" style={{fontSize: '40px'}}></i>
          </a>
        </div>
    </div>
  )
}

export default Footer
